<template>
  <div class="index">
    <div class="header" @click="goDetail">
      <img
        class="noselect"
        style="width: 100%; display: block"
        src="@/assets/info/me_banner.png"
      />
      <div class="container">
        <van-image
          round
          width="60"
          height="60"
          fit="cover"
          :src="require('@/assets/info/default_avatar.png')"
          class="user-icon"
        />
        <div class="user-name">
          {{ loginName || '请登录' }}
          <span class="tag">{{ userInfo.accountType || '个人' }}</span>
        </div>
      </div>
    </div>
    <template v-if="flag">
      <div class="login-box">
        <div class="login-icon">
          <img
            src="@/assets/info/me_login.png"
            style="width:70px;height:70px"
          />
          <span>请登录账号</span>
        </div>
        <van-button block class="login-btn" @click.stop="login">
          登录
        </van-button>
      </div>
    </template>
    <template v-else>
      <van-cell-group inset class="menu">
        <van-cell
          :title="item.label"
          is-link
          title-class="cell-title"
          :value-class=" {
            'account-wait': index == 0 && (userFullInfo.YHZT == '0' || userFullInfo.YHZT == '4'),
            'account-passed': index == 0 && userFullInfo.YHZT == '1',
            'account-warning': index == 0 && (userFullInfo.YHZT == '2' || userFullInfo.YHZT == '3'),
          }"
          @click="toNext(item)"
          v-for="(item, index) in menu"
          :key="index"
          :value="index == 0 && getYHZT(userFullInfo.YHZT)"
        >
          <template #icon>
            <img class="icon" :src="item.icon">
          </template>
          <template #title v-if="index==0">
            <span class="custom-title">{{ item.label }}</span>
            <van-tag type="warning" v-if="userFullInfo.YHZT == '4'">{{userFullInfo.accountState || '待完善'}}</van-tag>
          </template>
        </van-cell>
      </van-cell-group>
    </template>
    <!--目前没有退出功能-->
    <div class="logout-box">
      <div class="menu-box"  v-if="!flag">
        <van-button block @click.stop="confirmLogOut">退出登录</van-button>
      </div>
      <div class="support-info-bg">
        <div class="">{{personConfigInfo.organizer}}</div>
        <div class="">{{personConfigInfo.developmentUnit}}</div>
      </div>
    </div>
  </div>
</template>
<script>
import api from '@/utils/api/personCenter'
import moduleMixins from '@/mixins/moduleMixins'

export default {
  name: 'Index',
  components: {},
  mixins: [moduleMixins],
  props: {},
  data() {
    return {
      flag: true, //登录为true ，未登录为false
      menu: [
        { label: '账号信息', icon: require('@/assets/info/icon_1.png'), name: 'PersonalCenterDetail', path: 'personal-center/detail' },
        { label: '账号安全', icon: require('@/assets/info/icon_2.png'), name: 'PersonalCenterSecurity', path: 'personal-center/security' },
        { label: '材料中心', icon: require('@/assets/info/icon_3.png'), name: 'MaterialHome', path: 'personal-center/material-home' },
        { label: '咨询与投诉', icon: require('@/assets/info/icon_4.png'), name: 'ConsultComplaiont', path: 'consult-complaiont' },
      ],
      SHZT:"",// 账号状态值
      // info: {}, // 用户信息
      footerContent: this.$store.state.footerContent,
      loginName: null,
      userInfo:{},// 用户信息
      userFullInfo:{},// 用户完整信息
      personConfigInfo:{},// 个人中心配置
      accountStatusArr:[
        {
          value: 0,
          color: '#FFA403',
          text: '未审核',
          actionText: '',
        },
        {
          value: 1,
          color: '#0BDE78',
          text: '审核通过',
          actionText: '',
        },
        {
          value: 2,
          color: 'red',
          text: '审核不通过',
          actionText: '',
        },
        {
          value: 3,
          color: 'red',
          text: '禁用',
          actionText: '',
        },
        {
          value: 4,
          color: '#FFA403',
          text: '完善信息',
          actionText: '待完善',
        }
      ],// 审核状态数组
      that:this,
    }
  },
  computed: {
    navTitle() {
      return '个人中心'
    }
  },
  filters:{
    getYHZT2(val){
      let accountStatusArr = that.accountStatusArr
      if(val){
        for(let i = 0; i < accountStatusArr.length; i++){
          if(String(accountStatusArr[i].value) == String(val)){
            console.log("accountStatusArr[i].text :",accountStatusArr[i].text );
            return accountStatusArr[i].text 
          }
        }
      }else{
        return 
      }
    },
  },
  watch: {
    $route: {
      handler() {
        // console.log('+++++++', this.userFullInfo)
        // 让登录后返回也能获取数据
        if(!this.userFullInfo || JSON.stringify(this.userFullInfo)=='{}') {
          this.getData()// 获取用户信息
        }
      },
      deep: true,
      immediate: true // 第一次赋值也要触发监听
    }
  },
  methods: {
    getData() {
      let params = {}
      // 获取用户完整信息
      api
        .getLoginUserInfo(params)
        .then(res => {
          console.log(res)
          if(res.code==0) {
            this.userFullInfo = res.data
            // 账号审核状态是否待审核
            // this.toImprove = this.userFullInfo.YHZT == '0' ? true : false
            this.$store.commit('setFullUserInfo', res.data)
            this.flag = false

            if(this.userFullInfo.accountType == '企业'){
              this.loginName = this.userFullInfo.DWMC
            }else{// 如果为个人账户
              if(this.userFullInfo.LXR){
                this.loginName = this.userFullInfo.LXR
              }else{
                this.loginName = this.userFullInfo.loginName
              }
            }
          }
          // if(res.code == 500) {
          //   this.flag = true
          //   this.$dialog.confirm({
          //     title: '—— 温馨提示 ——',
          //     message: res.message,
          //     confirmButtonText: '去登录',
          //     confirmButtonColor: '#1D84FF'
          //   })
          //   .then(() => {
          //     this.login()
          //   })
          // }
        })
        // .catch(err => {
        //   console.log(err.response)
        //   let errInfo = err.response
        //   if(errInfo.data.code == 500){
        //     this.$dialog.confirm({
        //       title: '—— 温馨提示 ——',
        //       message: err.response.data.message,
        //       confirmButtonText: '去登录',
        //       confirmButtonColor: '#1D84FF'
        //     })
        //     .then(() => {
        //       this.login()
        //     }).catch(() => {
        //       this.logOut()
        //     });
        //   }
        // })
    },
    getPersonConfig(){
      let params = {}
      // 获取个人中心配置底部信息
      api
        .getPersonConfig(params)
        .then(res => {
          console.log("getPersonConfig:",res)
          this.personConfigInfo = res.data
        })
        .catch(err => {

        })
    },
    // 获取账号状态
    getYHZT(val){
      console.log('getYHZT:',val,typeof val);
      let accountStatusArr = this.accountStatusArr
      for(let i = 0; i < accountStatusArr.length; i++){
        if(String(accountStatusArr[i].value) == String(val)){
          return accountStatusArr[i].text 
        }
      }
   
    },
    goDetail() {
      if (this.userInfo && this.info.loginName) {
        this.toNext({
          name: 'PersonalCenterDetail', 
          path: 'personal-center/detail'
        })
      }
    },
    toNext(item) {
      if (window.__wxjs_environment === 'miniprogram') {
        wx.miniProgram.navigateTo({
          url: '/pages/webPage/webPage?webUrl=' + item.path
        })
      } else {
        this.$router.push({
          name: item.name
        })
      }
    },
    confirmLogOut(){
      this.$dialog.confirm({
        title: '—— 温馨提示 ——',
        message: '是否确认退出登录',
        confirmButtonText: '确认',
        confirmButtonColor: '#1D84FF'
      })
      .then(() => {
        this.logOut()
      }).catch(() => {
        // on cancel
      })
    },
    logOut() {
      // if (this.$store.state.loginConfig.isHaveThirdLogin == 1) {
      //   if (window.__wxjs_environment === 'miniprogram') {
      //     wx.miniProgram.navigateTo({
      //       url: '/pages/logOut/logOut'
      //     })
      //   } else {
      //     this.$toast('请使用小程序登录')
      //   }
      // }
      let params = {}
      api
        .logOut(params)
        .then(res => {
          console.log("logOut:",res)
          if(res.code==0) {
            this.$store.commit('cleanUserInfo')
            localStorage.removeItem('userInfo')// 清除用户登录信息
            localStorage.removeItem('userFullInfo')// 清除用户包括附件的用户信息

            this.userInfo = ''
            this.loginName = ''
            this.userFullInfo = ''
            this.flag = true
            
            // // 保留loginName，以防渲染报错
            // this.$store.commit('setUserInfo', {
            //   loginName: null
            // })
          }
        })
        .catch(err => {

        })
    },
    login() {
      if (this.$store.state.loginConfig.isHaveThirdLogin == '1') {
        //第三方登录，统一身份登录一定要小程序
        if (window.__wxjs_environment === 'miniprogram') {
          wx.miniProgram.navigateTo({
            url: '/pages/faceWebview/faceWebview?currentUserType=1'
          })
        } else {
          this.$toast('请使用小程序登录')
        }
      } else {
        if (window.__wxjs_environment === 'miniprogram') {
          wx.miniProgram.navigateTo({
            url: '/pages/webPage/webPage?webUrl=login?title=登录'
          })
        } else {
          this.$router.push({
            name: 'Login'
          })
        }
      }
    },
  },
  created() {},
  activated() {},
  mounted() {
    this.getPersonConfig()// 获取个人中心配置底部信息
    // this.$bus.$on('btnLogin', () => {
    //   this.getData()
    // })
  },
  destoryed() {}
}
</script>
<style lang="scss" scoped>
.index {
  .header {
    position: relative;
    padding: 15px 0;
    .container {
      box-sizing: border-box;
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      z-index: 1;
      // background-color: #aabbff33;
      display: flex;
      justify-content: center;
      align-items: center;
      //   padding: 0 10%;
      .user-icon {
        margin-left: 30px;
        border-radius: 100%;
        img {
          background-color: #fff;
        }
      }
      .user-name {
        flex: 1;
        margin-left: 10px;
        font-size: 14px;
        font-family: PingFang SC;
        font-weight: 500;
        color: #ffffff;
        .tag {
          display: inline-block;
          padding: 2px 5px;
          margin-left: 10px;
          font-size: 12px;
          color: #1d84ff;
          background-color: rgba(255,255,255,.6);
        }
      }
    }
  }
  .login-box {
    background-color: #ffffff;
    height: 240px;
    padding: 0px 20px;
    .login-icon {
      width: 100%;
      padding-top: 30px;
      text-align: center;
      span {
        padding-top: 15px;
        display: block;
        font-size: 14px;
        font-weight: 500;
        color: #333333;
      }
    }
    .login-btn {
      background: #1d84ff;
      box-shadow: 0px 2px 6px 0px rgba(29, 132, 255, 0.5);
      border-radius: 5px;
      text-align: center;
      font-size: 16px;
      font-weight: bold;
      color: #ffffff;
      height: 44px;
      border: 1px solid transparent;
      margin-top: 30px;
    }
  }
}

.menu {
  .van-cell {
    justify-content: center;
    align-items: center;
    padding: 15px 18px;
    .cell-title {
      // font-size: 20px;
      font-family: PingFang SC;
      font-weight: 450;
      color: #333333;
      margin-left: 10px;
      line-height: 1;
    }
    .account-passed{
      color: #52c41a;
    }
    .account-wait {
      color: #FFA403;
    }
    .account-warning{
      color: red;
    }
    .custom-title {
      margin-right: 10px;
    }
    .icon {
      width: 30px;
    }
  }
}

.logout-box {
  box-sizing: border-box;
  width: 100%;
  padding: 0 15px;
  position: fixed;
  bottom: 100px;
  .menu-box {
    padding-bottom: 30px;
    border-radius: 5px;
    .logout {
      font-size: 16px;
      font-weight: bold;
      color: #333333;
    }
  }
  .support-info-bg{
    font-size: 12px;
    font-weight: 500;
    color: #C4C4C4;
    text-align: center;
  }
}

</style>
